import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
import { toRefs } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DialogHeader',
    props: {
        title: { default: 'Title' },
        onCancel: { type: Function, default: () => { } },
        isHideCloseBtn: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        const { title, onCancel, isHideCloseBtn, } = toRefs(props);
        /**
         * 취소 버튼 클릭 핸들러
         */
        const handleCancel = () => {
            onCancel.value();
        };
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_card_title = _resolveComponent("v-card-title");
            return (_openBlock(), _createBlock(_component_v_card_title, { class: "dialog__title header-title-text d-flex align-center" }, {
                default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(title)) + " ", 1 /* TEXT */),
                    (!_unref(isHideCloseBtn))
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            icon: "mdi-close",
                            variant: "text",
                            class: "btn-close",
                            onClick: handleCancel
                        }))
                        : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
